import * as $runtime from "../runtime.js";
import * as Control$dApplicative from "../Control.Applicative/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Restaumatic$dCoreSites$dTranslations$dKeys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dPriceView from "../Restaumatic.Menu.V2.PriceView/index.js";
import * as Restaumatic$dMenu$dV2$dProductKey from "../Restaumatic.Menu.V2.ProductKey/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
const menuItemVariants = locale => catalogueMemo => menuSection => productId => product => itemParameters => {
  const catalogue = catalogueMemo.catalogue;
  const $0 = Restaumatic$dMenu$dV2$dParametric.applyParameters(Data$dRecord.unsafeGet("variants")(product))(itemParameters).remainingOptions;
  const variants = Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(v1 => {
    const allParams = Data$dMap$dInternal.unionWith(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Data$dFunction.const)(v1.variantParamValues)(itemParameters);
    const v2 = Restaumatic$dMenu$dV2$dProductKey.mkProductKey(catalogueMemo)(productId)(product)(allParams);
    const $1 = Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(product.variants)(allParams)
      ? Restaumatic$dMenu$dV2$dPriceView.priceView(product.price)(allParams)
      : Data$dMaybe.Nothing;
    if ($1.tag === "Just") {
      return Data$dMaybe.$Maybe(
        "Just",
        {
          label: v1.variantParamChoices.length === 0
            ? Data$dMaybe.Nothing
            : Data$dMaybe.$Maybe(
                "Just",
                Data$dFoldable.foldlArray(v => x => {
                  if (v.init) { return {init: false, acc: x}; }
                  return {init: false, acc: v.acc + " / " + x};
                })({init: true, acc: ""})(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.name))(v1.variantParamChoices)).acc
              ),
          price: Data$dMaybe.$Maybe("Just", $1._1),
          params: Data$dMaybe.$Maybe("Just", allParams),
          isAvailable: Data$dFoldable.foldableArray.foldMap({mempty: true, Semigroup0: () => ({append: v => v1$1 => v && v1$1})})(choice => Data$dRecord.unsafeGet("availability")(choice).tag === "Available")(v1.variantParamChoices) && Data$dRecord.unsafeGet("availability")(product).tag === "Available",
          productKey: v2.productKey,
          requiresCreator: v2.requiresCreator,
          canBeEdited: v2.canBeEdited
        }
      );
    }
    return Data$dMaybe.Nothing;
  })(Data$dArray.filter(v1 => {
    const allParams = Data$dMap$dInternal.unionWith(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Data$dFunction.const)(v1.variantParamValues)(itemParameters);
    return Data$dFoldable.foldableArray.foldMap({mempty: true, Semigroup0: () => ({append: v => v1$1 => v && v1$1})})(choice => {
      const $1 = Data$dRecord.unsafeGet("availability")(choice);
      return ($1.tag === "Available" || $1.tag === "TemporarilyUnavailable" || !($1.tag === "Hidden")) && Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("availableWhen")(choice))(allParams);
    })(v1.variantParamChoices) && Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible($0)(v1.variantParamValues) && Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("variants")(product))(allParams);
  })(Data$dFunctor.arrayMap(subvariants => (
    {
      variantParamValues: Data$dFoldable.foldableArray.foldMap({
        mempty: Data$dMap$dInternal.Leaf,
        Semigroup0: () => ({append: Data$dMap$dInternal.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})
      })(x => x)(Data$dFunctor.arrayMap(Data$dTuple.fst)(subvariants)),
      variantParamChoices: Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(Data$dTuple.snd)(subvariants))
    }
  ))(Data$dTraversable.traversableArray.traverse(Control$dApplicative.applicativeArray)(x => x)(Data$dSemigroup.concatArray([
    [Data$dTuple.$Tuple(Data$dMap$dInternal.Leaf, Data$dMaybe.Nothing)]
  ])(Data$dFunctor.arrayMap(v1 => {
    const $1 = v1._1;
    return Data$dFunctor.arrayMap(v1$1 => Data$dTuple.$Tuple(
      Data$dMap$dInternal.$$$Map(
        "Two",
        Data$dMap$dInternal.Leaf,
        Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("CustomParameter", $1),
        Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId("CustomParameterChoice", v1$1._1),
        Data$dMap$dInternal.Leaf
      ),
      Data$dMaybe.$Maybe("Just", v1$1._2)
    ))(v1._2.choices._2);
  })(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(parameterId => {
    const $1 = Data$dTuple.Tuple(parameterId);
    const $2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(parameterId)(Data$dRecord.unsafeGet("customParameters")(catalogue));
    if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", $1($2._1)); }
    return Data$dMaybe.Nothing;
  })(Data$dArray.filter(p => {
    const $1 = Data$dMap$dInternal.lookup(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("CustomParameter", p))(itemParameters);
    if ($1.tag === "Nothing") { return true; }
    if ($1.tag === "Just") { return false; }
    $runtime.fail();
  })(Data$dRecord.unsafeGet("dropdownParameters")(menuSection)))))))))));
  return Data$dSemigroup.concatArray(variants)(Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v => v1 => v || v1})})(v1 => v1.canBeEdited)(variants) && !Data$dFoldable.foldableArray.foldMap({
    mempty: true,
    Semigroup0: () => ({append: v => v1 => v && v1})
  })(v1 => v1.requiresCreator)(variants)
    ? [
        {
          label: Data$dMaybe.$Maybe(
            "Just",
            Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.menu.menuSectionItem.customize), {})
          ),
          price: Data$dMaybe.Nothing,
          params: Data$dMaybe.Nothing,
          isAvailable: Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v => v1 => v || v1})})(v1 => v1.isAvailable)(variants),
          productKey: Restaumatic$dMenu$dV2$dProductKey.mkProductKey(catalogueMemo)(productId)(product)(itemParameters).productKey,
          requiresCreator: true,
          canBeEdited: true
        }
      ]
    : []);
};
export {menuItemVariants};
